import { render, staticRenderFns } from "./OnboardingPollDrawer.vue?vue&type=template&id=2604f3a1&scoped=true&"
import script from "./OnboardingPollDrawer.vue?vue&type=script&lang=js&"
export * from "./OnboardingPollDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPollDrawer.vue?vue&type=style&index=0&id=2604f3a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604f3a1",
  null
  
)

export default component.exports